// How good the admin's connection is for running a live session, from the download speed
// (useNetworkSpeed) - the Internet card's wifi icon colour: good (green), fair (yellow),
// poor (red); null without a reading.
export function speedQuality(mbps) {
  if (typeof mbps !== "number" || !Number.isFinite(mbps)) return null;
  if (mbps >= 5) return "good";
  if (mbps >= 1.5) return "fair";
  return "poor";
}
